import { RawMaterialMasterThemeModeConfig } from './types';

const dark: RawMaterialMasterThemeModeConfig = {
  rawMaterialMaster: {},
};

export default dark;
